import './Tours.css';
import { Link } from 'react-router-dom';

const Tours = (props) => {
    const {name, image, days, price} = props.tour;

    return (
        <div className="tour-card shadow-lg">
            <img src={image} alt="" />
            <h1 className="fs-3 py-3">{name}</h1>
            <p className="fs-5"><i className="fas fa-hourglass-half icon"></i> {days}</p>
            <hr />
            <div className="btn-container">
            <Link to={"/order"}>
                <div><button className="btn">BUY NOW</button></div>
            </Link>
                <div><h5 className="font-bold">Price: $ {price}</h5></div>
            </div> 
        </div>
    );
};

export default Tours;